import { Api } from '../api/api';
import { User } from '../user/user';
import { Injectable } from '@angular/core';
import {LocalDataSource} from '../../ng2-smart-table/lib/data-source/local/local.data-source';
import {AlertData} from '../../interfaces/alert-data';

/*
  Generated class for the PatientAlertProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PatientAlertProvider {

  alertData: Array<AlertData> = [];
  tableData: LocalDataSource = new LocalDataSource();
  activeAlertData: AlertData = new AlertData();

  constructor(public api: Api, private user: User) {
    this.addRefreshAlertData();
  }

  addRefreshAlertData() {
    this.api.socket.removeAllListeners('refreshAlertData');
    this.api.socket.on('refreshAlertData', this.refreshAlertData.bind(this));
  }

  private refreshAlertData() {
    this.get();
  }

  checkAlertAccess(patientAlertGroup: Array<string> = []): Promise<Array<string>> {

    return new Promise((resolve, reject) => {

      const returnGroups = [];
      const aktDate = new Date();
      const actTime = parseInt((aktDate.getHours() + ':' + aktDate.getMinutes()).replace(':', ''), 10);

      this.user.get(this.api._user.user_id).then((user_res: any) => {

        const alertGroups = user_res.data.data.data.docs[0].profile.alertGroups;
        const alertTime = user_res.data.data.data.docs[0].profile.alertTime;

        patientAlertGroup.forEach((groupName) => {
          if (alertGroups) {
            if (alertGroups.indexOf(groupName) !== -1) {
              if (alertTime) {
                if (alertTime[aktDate.getDay()]) {
                  alertTime[aktDate.getDay()].forEach((timeObj) => {
                    if (timeObj.active) {
                      const from = parseInt(timeObj.from.replace(':', ''), 10);
                      const to = parseInt(timeObj.to.replace(':', ''), 10);

                      if (actTime >= from && actTime <= to) {
                        returnGroups.push(groupName);
                      }

                    }
                  });
                }
              } else {
                returnGroups.push(groupName);
              }
            }

          }
        });

        resolve(returnGroups.filter((v, i, a) => a.indexOf(v) === i));
      }).catch((err) => {
        reject(err);
        console.log(err);
      });



    });
  }

  socketPushAlert(params?: any): AlertData {
    this.add(params);
    return params;
  }

  quit(formData) {
    return new Promise<void>((resolve, reject) => {
      this.activeAlertData.quit = {
        reason: formData.reason,
        comment: formData.comment,
        person: this.api._user.profile.firstname + ' ' + this.api._user.profile.lastname,
        dateTime: new Date().getTime()
      };
      this.api.put('quitAlert', { body: this.activeAlertData }).subscribe({next:(resp: any) => {
        this.activeAlertData._rev = resp.data.data.rev;
        resolve();
      }, error:() => {
        reject();
      }});
    });
  }

  get() {
    return this.api.get('alert');
  }

  getById(docId: string) {
    return this.api.get('alertDoc', { docId });
  }

  add(_alert: AlertData) {
    _alert.dateTime = new Date().getTime();
    this.tableData.append(_alert);
  }

  delete(_alert: AlertData) {
    this.alertData.splice(this.alertData.indexOf(_alert), 1);
    this.tableData.remove(_alert);
  }

  /**
   *
   * Startet den Rückruf an den Patienten
   *
   * @param alertData:AlertData
   */
  alertCallPatient(alertData: AlertData) {
    alertData.notrufCallNumber = this.api._user.profile.callNumber;
    return this.api.post('redirectCall', { body: alertData });
  }


}
